import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "add-benchmark-page",
  class: "page add-benchmark-page"
}
const _hoisted_2 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_AppUploader = _resolveComponent("AppUploader")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, { class: "mt-4 pa-0" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    onSubmit: _withModifiers(_ctx.addBenchmark, ["prevent"]),
                    class: "py-5"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between mb-6" }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("span", { class: "text-h5" }, " Add Benchmark ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createTextVNode("Name", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            "persistent-hint": false,
                            variant: "underlined",
                            placeholder: "Fund Name to appear in the report",
                            modelValue: _ctx.priceTrackObject.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.priceTrackObject.name) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode("First Date (YYYY-MM-DD)", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            "persistent-hint": false,
                            variant: "underlined",
                            placeholder: "Start Date",
                            modelValue: _ctx.priceTrackObject.startDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.priceTrackObject.startDate) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode("End Date (YYYY-MM-DD)", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, {
                            "hide-details": "",
                            "persistent-hint": false,
                            variant: "underlined",
                            placeholder: "Should be present in the price track that you upload",
                            modelValue: _ctx.priceTrackObject.endDate,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.priceTrackObject.endDate) = $event)),
                            class: "mb-5"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_AppUploader, {
                            "data-testid": "FileUpload",
                            onAppUploader: _ctx.handleFile,
                            disabled: _ctx.addingBenchmark,
                            fileType: '.csv'
                          }, null, 8, ["onAppUploader", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            "data-testid": "SubmitUploadBtn",
                            color: _ctx.addingBenchmark ? 'disabled' : 'success',
                            type: "submit",
                            variant: "flat",
                            loading: _ctx.addingBenchmark,
                            disabled: _ctx.addingBenchmark
                          }, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                              _createTextVNode("Add", -1)
                            ]))]),
                            _: 1
                          }, 8, ["color", "loading", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}